<template>
  <profile-form @userUpdated="$emit('userUpdated', $event)" />
</template>

<script>
import ProfileForm from '@/components/misc/ProfileForm';

export default {
  components: {
    ProfileForm
  }
}
</script>
